export default __webpack_public_path__ + "static/media/search-solid.fb5a13db.svg";